<template>
  <div v-if="lane_id != null">
    <Lane :lane_id="lane_id"/>
  </div>
</template>

<script>
import Lane from "../components/Lane.vue";

export default {
  name: 'LanesViewer',
    components : {
      Lane
    },
    computed: {
    },
    data () {
        return {
          debugMode: (process.env.VUE_APP_DEBUG_MODE === "true" ? true : false),
          publicPath: process.env.BASE_URL,
          lane_id: null,
          isLoading: true
        }
    },
    methods:{
    },
    mounted(){
      this.lane_id = this.$route.params.lane_id;
      console.log("LanesViewer mounted",this.lane_id);
    }
}
</script>

<style lang="scss" scoped>

</style>